import { FC, useState } from "react";
import "./CustomHelpComponent.scss";
import HelpIcon from "../../assets/icons/web-help-icon.svg";
import CallUs from "../../features/Feature_GeneralAppElements/CallUs/CallUs";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import TriggerGTAEvent from "../../utils/GTA";
import { useLocation } from "react-router-dom";
import { getGTAEventScreenType } from "../../utils/helper";

interface Props {
  functionalityCode?: string;
  LobId?: string;
  screenType?: string;
}

const CustomHelpComponent: FC<Props> = ({
  functionalityCode = "",
  LobId = "",
  screenType = "",
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const { pathname } = useLocation();
  const handleCleverTapCTAClick = () => {
    console.log("screenType",screenType)
    triggerCleverTapEvent("get_help_cta_click", {
      ScreenType: screenType,
      ScreenName: "HelpPopUp",
      isPrevPageNameRequired: true,
    });
    TriggerGTAEvent("get_help_cta_click", {
      screen_type: screenType,
      screen_name: "HelpPopUp",
    });
  };

  const handleGTAEvents = () => {
    TriggerGTAEvent("get_help_cta_click", {
      screen_type: getGTAEventScreenType(pathname)?.screen_type,
      screen_name: getGTAEventScreenType(pathname)?.screen_name,
      isPrevPageNameRequired: true,
    });
  };

  return (
    <>
      <img
        src={HelpIcon}
        onClick={() => {
          handleGTAEvents();
          handleCleverTapCTAClick();
          handleGTAEvents();
          setOpen(true);
        }}
        alt="help-icon"
        className="help-icon"
      />
      {open && (
        <CallUs
          open={open}
          handleOpen={setOpen}
          functionalityCode={functionalityCode}
          LobId={LobId}
          // showChatWithUsBtn={true}
        />
      )}
    </>
  );
};

export default CustomHelpComponent;
